class ExtendSectionHome extends ExtendSectionBase {
  constructor() {
    super();
  }

  init() {
    this._listenSectionLoad();
    const _safeInit = (fn) => {
      try {
        return fn();
      } catch (e) {
        console.warn(`[ExtendSectionS1V3] ${fn.name} 初始化失败:`, e);
        return null;
      }
    };
    _safeInit(() => this.initNewsCardsScroll());
    _safeInit(() => this.initNewsListScroll());
    _safeInit(() => this.initTestimonials());
    _safeInit(() => this.initTestimonials02());
    _safeInit(() => this.initAwards02Cards());
    _safeInit(() => this.initSlideshow());
    _safeInit(() => this.initProductFeatures02Slideshow());
    _safeInit(() => this.initIndexBanner());
  }

  initNewsCardsScroll() {
    const $newsCardsScroll = $('[name="extend-news-cards-scroll"]');
    if (!$newsCardsScroll.length) return;
    this._registerSectionLoad(
      "extend_news_cards",
      "extend-news-cards",
      "initNewsCardsScroll"
    );
    this._clearFlktyList("newsCardsFlktyList");
    this._flktyListObj.newsCardsFlktyList = [];
    $newsCardsScroll.each((index, element) => {
      const flkty = new Flickity(element, {
        cellAlign: "left",
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        wrapAround: false,
        prevNextButtons: false,
        pageDots: false,
      });
      flkty.on("dragEnd", () => setTimeout(() => flkty.playPlayer(), 100));
      this._flktyListObj.newsCardsFlktyList.push(flkty);
    });
  }

  initNewsListScroll() {
    const $newsListScroll = $('[name="extend-news-list-scroll"]');
    if (!$newsListScroll.length) return;
    this._registerSectionLoad(
      "extend_news_list",
      "extend-news-list",
      "initNewsListScroll"
    );
    this._clearFlktyList("newsListFlktyList");
    this._flktyListObj.newsListFlktyList = [];
    $newsListScroll.each((index, element) => {
      const flkty = new Flickity(element, {
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
      });
      flkty.on("dragEnd", () => setTimeout(() => flkty.playPlayer(), 100));
      this._flktyListObj.newsListFlktyList.push(flkty);
    });
  }

  initTestimonials() {
    const $testimonials = $('[name="extend-testimonials"]');
    if (!$testimonials.length) return;
    this._registerSectionLoad(
      "extend_testimonials",
      "extend-testimonials",
      "initTestimonials"
    );
    const $testimonials_mobile = $('[name="extend-testimonials-mobile"]');
    this._clearFlktyList("testimonialsFlktyList");
    this._flktyListObj.testimonialsFlktyList = [];
    $testimonials.each((index, element) => {
      const $videos = $(element).find('[name="extend-testimonials-videos"]');
      const flkty = new Flickity($videos.get(0), {
        cellAlign: "left",
        contain: true,
        groupCells: true,
        pageDots: false,
        prevNextButtons: true,
      });
      this._flktyListObj.testimonialsFlktyList.push(flkty);
    });
    $testimonials_mobile.each((index, element) => {
      const $videos = $(element).find('[name="extend-testimonials-videos"]');
      const flkty = new Flickity($videos.get(0), {
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
      });
      flkty.on("dragEnd", () => setTimeout(() => flkty.playPlayer(), 100));
      this._flktyListObj.testimonialsFlktyList.push(flkty);
    });
  }

  initTestimonials02() {
    const $testimonials = $('[name="extend-testimonials02"]');
    if (!$testimonials.length) return;
    this._registerSectionLoad(
      "extend_testimonials02",
      "extend-testimonials02",
      "initTestimonials02"
    );
    const $testimonials_mobile = $('[name="extend-testimonials02-mobile"]');
    this._clearFlktyList("testimonials02FlktyList");
    this._flktyListObj.testimonials02FlktyList = [];
    $testimonials.each((index, element) => {
      const $videos = $(element).find('[name="extend-testimonials02-videos"]');
      const flkty = new Flickity($videos.get(0), {
        cellAlign: "left",
        contain: true,
        groupCells: true,
        pageDots: false,
        prevNextButtons: true,
      });
      this._flktyListObj.testimonials02FlktyList.push(flkty);
    });
    $testimonials_mobile.each((index, element) => {
      const $videos = $(element).find('[name="extend-testimonials02-videos"]');
      const flkty = new Flickity($videos.get(0), {
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
      });
      flkty.on("dragEnd", () => setTimeout(() => flkty.playPlayer(), 100));
      this._flktyListObj.testimonials02FlktyList.push(flkty);
    });
  }

  initAwards02Cards() {
    const $cards = $('[name="extend-awards02-cards"]');
    if (!$cards.length) return;
    this._registerSectionLoad(
      "extend_awards02_cards",
      "extend_awards02",
      "initAwards02Cards"
    );
    const $cards_mobile = $('[name="extend-awards02-cards-mobile"]');
    this._clearFlktyList("awardsCardsFlktyList");
    this._flktyListObj.awardsCardsFlktyList = [];
    $cards.each((index, element) => {
      const flkty = new Flickity(element, {
        cellAlign: "left",
        groupCells: 2,
        pageDots: false,
      });
      this._flktyListObj.awardsCardsFlktyList.push(flkty);
    });
    $cards_mobile.each((index, element) => {
      const flkty = new Flickity(element, {
        cellAlign: "left",
        autoPlay: 5000,
        pauseAutoPlayOnHover: false,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
      });
      flkty.on("dragEnd", () => setTimeout(() => flkty.playPlayer(), 100));
      this._flktyListObj.awardsCardsFlktyList.push(flkty);
    });
  }

  initSlideshow() {
    const $slideshow = $('[name="extend-slideshow"]');
    if (!$slideshow.length) return;
    this._registerSectionLoad(
      "extend_slideshow",
      "extend-slideshow",
      "initSlideshow"
    );
    const $slideshow_mobile = $('[name="extend-slideshow-mobile"]');
    this._clearFlktyList("slideshowFlktyList");
    this._flktyListObj.slideshowFlktyList = [];

    const _initSlideshow = (element, mainAlign) => {
      let activeIndex = 0;
      const $slideshowMain = $(element).find('[name="extend-slideshow-main"]');
      const $slideshowTabs = $(element).find('[name="extend-slideshow-tabs"]');
      const flkty = new Flickity($slideshowMain.get(0), {
        cellAlign: mainAlign,
        contain: true,
        pageDots: false,
        initialIndex: activeIndex,
        prevNextButtons: false,
      });
      const flktyTabs = new Flickity($slideshowTabs.get(0), {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        initialIndex: activeIndex,
        prevNextButtons: false,
        draggable: false,
      });
      flkty.on("select", () => {
        if (flkty.selectedIndex === activeIndex) return;
        activeIndex = flkty.selectedIndex;
        flktyTabs.select(activeIndex);
      });
      flktyTabs.on("select", () => {
        if (flktyTabs.selectedIndex === activeIndex) return;
        activeIndex = flktyTabs.selectedIndex;
        flkty.select(activeIndex);
      });
      flktyTabs.on("staticClick", (event, pointer, cellElement, cellIndex) => {
        if (cellIndex === activeIndex) return;
        flkty.select(cellIndex);
        flktyTabs.select(cellIndex);
      });
      this._flktyListObj.slideshowFlktyList.push(flkty, flktyTabs);
    };

    $slideshow.each((index, element) => _initSlideshow(element, "left"));
    $slideshow_mobile.each((index, element) =>
      _initSlideshow(element, "center")
    );
  }

  initProductFeatures02Slideshow() {
    const $slideshow_mobile = $('[name="extend-product-features02-mobile"]');
    if (!$slideshow_mobile) return;
    this._registerSectionLoad(
      "extend_product_features02_slideshow",
      "extend-product-features02",
      "initProductFeatures02Slideshow"
    );
    this._clearFlktyList("productFeatures02SlideshowFlktyList");
    this._flktyListObj.productFeatures02SlideshowFlktyList = [];
    $slideshow_mobile.each((index, element) => {
      let activeIndex = 0;
      const $slideshowMain = $(element).find(
        '[name="extend-product-features02-slideshow-main"]'
      );
      const $slideshowTabs = $(element).find(
        '[name="extend-product-features02-slideshow-tabs"]'
      );
      const flkty = new Flickity($slideshowMain.get(0), {
        cellAlign: "center",
        contain: true,
        pageDots: false,
        initialIndex: activeIndex,
        prevNextButtons: false,
      });
      const flktyTabs = new Flickity($slideshowTabs.get(0), {
        cellAlign: "left",
        contain: true,
        pageDots: false,
        initialIndex: activeIndex,
        prevNextButtons: false,
      });
      flkty.on("select", () => {
        if (flkty.selectedIndex === activeIndex) return;
        activeIndex = flkty.selectedIndex;
        flktyTabs.select(activeIndex);
      });
      flktyTabs.on("select", () => {
        if (flktyTabs.selectedIndex === activeIndex) return;
        activeIndex = flktyTabs.selectedIndex;
        flkty.select(activeIndex);
      });
      flktyTabs.on("staticClick", (event, pointer, cellElement, cellIndex) => {
        if (cellIndex === activeIndex) return;
        flkty.select(cellIndex);
        flktyTabs.select(cellIndex);
      });
      this._flktyListObj.productFeatures02SlideshowFlktyList.push(
        flkty,
        flktyTabs
      );
    });
  }

  initIndexBanner() {
    const $slideshow = $(".extend-index-banner");
    if (!$slideshow.length) return;
    this._registerSectionLoad(
      "extend_index_banner",
      "extend-index-banner-section",
      "initIndexBanner"
    );
    this._clearFlktyList("indexBannerFlktyList");
    this._flktyListObj.indexBannerFlktyList = [];
    $slideshow.each((index, element) => {
      const flkty = new Flickity(element, {
        pageDots: true,
        prevNextButtons: true,
        autoPlay: false,
        pauseAutoPlayOnHover: false,
      });
      flkty.on("dragEnd", () => setTimeout(() => flkty.playPlayer(), 100));
      this._flktyListObj.indexBannerFlktyList.push(flkty);
    });
  }
}
